import axiosInstance from "../../../interceptor/intercetptor-inctence";

export const getProfileData = (formData) => {
    return axiosInstance.post(`api/lab-user/profile`, formData);
}

export const updateProfileData = (formData,id) => {
    return axiosInstance.post(`api/lab-user/update-profile/${id}`, formData);
}

export const logoProfileData = (form_data) => {
    return axiosInstance.post(`api/lab-user/update-logo`, form_data);
}

export const changePassword = (formData) => {
    return axiosInstance.post(`api/lab-user/change-password`, formData);
}

export const stateMaster = (formData) => {
    return axiosInstance.post(`api/global-master/master-state`, formData);
}

export const districtMaster = (formData) => {
    return axiosInstance.post(`api/global-master/master-district`, formData);
}

export const cityMaster = (formData) => {
    return axiosInstance.post(`api/global-master/master-city`, formData);
}

export const pincodeMaster = (formData) => {
    return axiosInstance.post(`api/global-master/master-pincode`, formData);
}

export const upgradPlan = (formData) => {
    return axiosInstance.post(`api/lab-user/update-plan`, formData);
}

export const getMessageCount = () => {
    return axiosInstance.post(`api/dashboard/messages-count`, {});
}

